import React from "react";
import {
  titleCodes,
  textCodes,
} from "../../template_codes/cetaphilmm/contace_page_codes";

function Contact() {
  return (
    <div className="py-20 lg:text-center xl:text-center pl-10 bg-cetaphil_contact bg-cover">
      <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold py-10">
        {titleCodes.contactTitle.title}
      </h1>
      <ul className="list-none">
        <li className="pb-8">
          <p className="text-lg pt-2 lg:text-xl xl:text-xl">
            {textCodes.fbTitle.text}
          </p>
          <a href="https://www.facebook.com/cetaphilmyanmar" target="_blank">
            <p className="text-md pt-2 lg:text-xl xl:text-xl">
              {textCodes.fbText.text}
            </p>
          </a>
        </li>
        <li className="pb-8">
          <p className="text-lg pt-2 lg:text-xl xl:text-xl">
            {textCodes.phTitle.text}
          </p>
          <p className="text-md pt-2 lg:text-xl xl:text-xl">
            {textCodes.phText.text}
          </p>
          <p className="text-md pt-2 lg:text-xl xl:text-xl">
            {textCodes.phText.text2}
          </p>
          <p className="text-md pt-2 lg:text-xl xl:text-xl">
            {textCodes.phText.text3}
          </p>
        </li>
        <li className="pb-8">
          <p className="text-lg pt-2 lg:text-xl xl:text-xl">
            {textCodes.emailTitle.text}
          </p>
          <p className="text-md pt-2 lg:text-xl xl:text-xl">
            {textCodes.emailText.text}
          </p>
        </li>
        <li className="pb-2">
          <p className="text-lg pt-2 lg:text-xl xl:text-xl">
            Address
          </p>
          <p className="text-md pt-2 lg:text-xl xl:text-xl">
            {textCodes.addressText.text}
          </p>
        </li>
      </ul>
    </div>
  );
}

export default Contact;
